export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readCount: number;
  commentCount: number;
  likes: number;
  image: string;
  tags: string[];
  featured: boolean;
  hot: boolean;
}

export const articles: Article[] = [
  {
    id: 'art-001',
    title: '某顶流男星深夜密会神秘女子，酒店同出画面曝光',
    excerpt: '据知情人士透露，该男星近日被拍到与一名神秘女子深夜出入某五星级酒店，两人举止亲密，引发粉丝热议。',
    content: `<p>近日，有网友爆料称在某五星级酒店门口拍到某顶流男星与一名神秘女子同行的画面。据拍摄者描述，两人于深夜11点左右先后进入酒店，次日清晨6点才分别离开。</p><p>该男星近年来人气飙升，凭借多部爆款剧集成为新一代流量担当。此前他一直以单身人设示人，此次被拍到与女子深夜同出酒店，引发网友热议。</p><p>有粉丝表示"可能是工作人员"，也有人认为"明星也有私生活，不必过度解读"。目前该男星方面尚未对此事作出回应。</p><blockquote><p>业内人士分析：该男星正处于事业上升期，此时曝光恋情可能对商业价值产生影响。但另一方面，真实坦诚的态度也可能赢得更多路人好感。</p></blockquote><p>我们将持续关注此事进展。</p>`,
    category: 'yule-bagua',
    author: '娱乐侦探小王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20casual%20stylish%20warm%20lighting%20neutral%20background%20professional%20headshot%20clean%20composition&width=80&height=80&seq=avatar-wang&orientation=squarish',
    publishDate: '2026-08-07',
    readCount: 128900,
    commentCount: 3456,
    likes: 28900,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20warm%20golden%20lighting%20elegant%20atmosphere%20paparazzi%20style%20photography%20dramatic%20shadows%20mysterious%20mood%20cinematic%20composition%20blurred%20figures%20in%20background&width=800&height=450&seq=art-001-main&orientation=landscape',
    tags: ['顶流男星', '恋情曝光', '酒店密会', '娱乐圈八卦'],
    featured: true,
    hot: true,
  },
  {
    id: 'art-002',
    title: '知名带货主播直播间翻车，宣称"纯天然"产品被检测出化学成分',
    excerpt: '消费者将直播中购买的产品送检后发现含有多种工业添加剂，与主播宣传的"纯天然零添加"严重不符。',
    content: `<p>近日，一位拥有千万粉丝的带货主播在直播中大力宣传一款"纯天然手工皂"，声称"零添加、孕妇可用"。然而有较真的消费者将产品送往专业机构检测后，发现该产品中含有多种工业香精和防腐剂。</p><p>检测报告显示，该手工皂中含有月桂醇聚醚硫酸酯钠（SLES）、甲基异噻唑啉酮（MIT）等多种化学成分，与主播宣称的"纯天然"完全不符。</p><blockquote><p>消费者李女士表示："我怀孕五个月了，就是冲着纯天然买的，现在知道含有化学成分，真的很后怕。"</p></blockquote><p>目前该主播已删除相关直播回放，但尚未公开回应此事。平台方面表示已关注此事，将按照相关规定处理。</p>`,
    category: 'daihuo-fanchu',
    author: '打假先锋',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20investigative%20reporter%20portrait%20serious%20expression%20clean%20background%20professional%20looking%20warm%20lighting&width=80&height=80&seq=avatar-dajia&orientation=squarish',
    publishDate: '2026-08-06',
    readCount: 96500,
    commentCount: 2890,
    likes: 21500,
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20beauty%20products%20on%20display%20dramatic%20lighting%20contrast%20between%20natural%20and%20chemical%20products%20investigative%20style%20photography&width=800&height=450&seq=art-002-main&orientation=landscape',
    tags: ['直播带货', '虚假宣传', '产品检测', '消费者权益'],
    featured: true,
    hot: true,
  },
  {
    id: 'art-003',
    title: '某选秀节目被曝内定冠军，知情人士曝出完整黑幕链条',
    excerpt: '多位参与节目的工作人员匿名爆料，称节目组从海选阶段就已确定最终排名，投票环节形同虚设。',
    content: `<p>一档正在热播的选秀节目近日被多位匿名工作人员爆料，称节目存在严重的内定问题。据爆料者称，节目组在选手海选阶段就已经确定了最终的前三名排名。</p><p>"观众的投票根本不影响结果，都是有剧本的，"一位自称参与节目制作的匿名人士表示，"每期淘汰谁都是提前开会定好的，选手的表现也会被后期剪辑刻意引导。"</p><p>另一位爆料者提供了部分内部聊天记录截图，显示节目组确实存在操控排名的行为。不过这些截图的真实性尚未得到独立验证。</p><blockquote><p>娱乐评论人分析：选秀节目内定问题由来已久，但如果爆料属实，将严重损害节目的公信力，也可能面临监管部门的调查。</p></blockquote>`,
    category: 'zongyi-jumu',
    author: '综艺扒姐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20trendy%20fashionable%20casual%20style%20warm%20lighting%20neutral%20background%20clean%20composition&width=80&height=80&seq=avatar-zongyi&orientation=squarish',
    publishDate: '2026-08-06',
    readCount: 87500,
    commentCount: 4120,
    likes: 19800,
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%20and%20shadows%20dark%20backstage%20atmosphere%20mysterious%20mood%20behind%20the%20scenes%20feeling%20cinematic%20lighting&width=800&height=450&seq=art-003-main&orientation=landscape',
    tags: ['选秀节目', '内定黑幕', '综艺造假', '投票操控'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-004',
    title: '网红"甜心姐姐"私下真实面目曝光，与镜头前人设判若两人',
    excerpt: '有网友偶遇该网红在餐厅对服务员态度恶劣，与其视频中温柔可亲的形象形成鲜明对比。',
    content: `<p>以"温柔知心大姐姐"人设走红的网红"甜心姐姐"，近日被网友曝光私下真实面目。据目击网友描述，其在某高档餐厅用餐时，因上菜速度稍慢便对服务员大声斥责，态度极为恶劣。</p><p>"完全不像视频里那个温柔的人，"目击者表示，"她说话特别难听，服务员都快哭了。"该网友还拍下了现场照片作为证据。</p><p>事件曝光后，"甜心姐姐"的社交账号评论区迅速沦陷。有粉丝表示失望脱粉，也有人认为不应以一次事件否定一个人。</p><blockquote><p>该网红随后发布道歉声明，称"当天情绪不佳，已向服务员道歉"，但多数网友并不买账，认为这是人设崩塌后的危机公关。</p></blockquote>`,
    category: 'wanghong-heiliao',
    author: '网红观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20media%20observer%20portrait%20smart%20casual%20professional%20look%20neutral%20background%20clean%20composition%20warm%20lighting&width=80&height=80&seq=avatar-observer&orientation=squarish',
    publishDate: '2026-08-05',
    readCount: 112000,
    commentCount: 5670,
    likes: 35200,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20restaurant%20interior%20with%20dramatic%20contrast%20between%20beautiful%20setting%20and%20tense%20atmosphere%20upscale%20dining%20soft%20warm%20lighting%20cinematic%20mood&width=800&height=450&seq=art-004-main&orientation=landscape',
    tags: ['网红翻车', '人设崩塌', '私下真面目', '甜心姐姐'],
    featured: true,
    hot: true,
  },
  {
    id: 'art-005',
    title: '深度扒皮：某知名MCN机构如何批量制造"假网红"',
    excerpt: '从购买粉丝到数据造假，从前台人设到幕后运营，深度揭秘网红产业链背后的灰色操作。',
    content: `<p>随着短视频和直播行业的爆发式增长，MCN机构如雨后春笋般涌现。然而在光鲜亮丽的网红背后，隐藏着怎样的灰色产业链？记者经过三个月深入调查，为您揭开MCN机构制造"假网红"的完整流程。</p><h4>第一步：批量购买粉丝和互动数据</h4><p>调查发现，几乎所有初创网红都会通过第三方渠道购买初始粉丝和互动数据。一个拥有百万粉丝的账号，真实粉丝可能不足十万。</p><h4>第二步：精心打造虚假人设</h4><p>MCN机构会为每个签约网红量身定制人设——从家庭背景、学历经历到兴趣爱好，全部经过精心设计。甚至会租用豪车、豪宅作为拍摄场景。</p><h4>第三步：数据维护与舆论操控</h4><p>持续购买播放量、点赞、评论等数据，维护网红的热度假象。同时雇佣水军在评论区引导舆论方向。</p><blockquote><p>某MCN机构前员工透露："这些操作在行业内已经是公开的秘密，大家都在做，不做反而成了异类。"</p></blockquote>`,
    category: 'wanghong-heiliao',
    author: '深度调查组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20journalist%20portrait%20serious%20professional%20investigative%20style%20clean%20background%20warm%20lighting&width=80&height=80&seq=avatar-deep&orientation=squarish',
    publishDate: '2026-08-04',
    readCount: 78500,
    commentCount: 3210,
    likes: 18400,
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20with%20multiple%20computer%20screens%20showing%20social%20media%20dashboards%20dark%20corporate%20atmosphere%20mysterious%20mood%20behind%20the%20scenes%20tech%20company%20investigative%20style&width=800&height=450&seq=art-005-main&orientation=landscape',
    tags: ['MCN机构', '假网红', '数据造假', '产业链'],
    featured: false,
    hot: false,
  },
  {
    id: 'art-006',
    title: '某女星被拍到与已婚富商同游日本，经纪人紧急公关',
    excerpt: '网友在东京偶遇该女星与一名中年男子举止亲密，随后被扒出男子为某上市公司已婚高管。',
    content: `<p>近日，有网友在日本东京银座偶遇某知名女星与一名中年男子同行购物。照片中两人举止亲密，该男子多次为女星提包、买单。</p><p>随后网友扒出该男子身份——某A股上市公司副总裁，已婚并育有两个孩子。这一信息让事件迅速升级。</p><p>事件发酵后，该女星经纪人火速发布声明，称两人只是"普通朋友关系"，此次日本之行是"多人商务旅行"。但爆料网友表示"只有他们两个，没有看到其他人"。</p><blockquote><p>法律人士指出：如果男方确实已婚，两人的亲密行为可能涉及婚内出轨问题，但这是道德层面的争议，不涉及法律问题。</p></blockquote>`,
    category: 'yule-bagua',
    author: '八卦一姐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20reporter%20female%20portrait%20stylish%20trendy%20look%20warm%20lighting%20neutral%20background%20clean%20composition&width=80&height=80&seq=avatar-bagua&orientation=squarish',
    publishDate: '2026-08-03',
    readCount: 145000,
    commentCount: 6780,
    likes: 42100,
    image: 'https://readdy.ai/api/search-image?query=Tokyo%20Ginza%20shopping%20district%20luxury%20stores%20elegant%20atmosphere%20paparazzi%20style%20photography%20golden%20hour%20lighting%20couple%20in%20distance%20blurred%20background&width=800&height=450&seq=art-006-main&orientation=landscape',
    tags: ['女星绯闻', '富商同游', '日本', '婚外情'],
    featured: true,
    hot: true,
  },
  {
    id: 'art-007',
    title: '某知名品牌直播中自曝产品成本仅售价5%，消费者炸锅',
    excerpt: '主播在直播中意外说漏嘴，透露某售价299元的产品实际成本不到15元，引发消费者强烈不满。',
    content: `<p>一场看似平常的直播带货中，主播在介绍一款售价299元的美容仪时，不小心说漏了嘴："这个东西成本就十几块钱，我们卖299其实利润很高......"</p><p>虽然主播立刻意识到失言并试图圆场，但这段画面已被网友录屏并在各大平台传播。随后更多网友扒出该品牌其他产品的成本信息，发现定价普遍是成本的10-20倍。</p><blockquote><p>消费者协会专家表示：虽然市场定价属于企业自主行为，但如果存在虚假宣传或价格欺诈，消费者有权投诉并要求赔偿。</p></blockquote><p>目前该品牌官方旗舰店已将所有直播回放下架，客服回应称"主播口误，实际成本远高于此"，但拒绝提供具体的成本构成。</p>`,
    category: 'daihuo-fanchu',
    author: '消费维权哥',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20consumer%20rights%20activist%20portrait%20determined%20expression%20casual%20professional%20warm%20lighting%20neutral%20background&width=80&height=80&seq=avatar-rights&orientation=squarish',
    publishDate: '2026-08-05',
    readCount: 103000,
    commentCount: 4560,
    likes: 28900,
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20beauty%20device%20products%20shocked%20expression%20dramatic%20lighting%20split%20screen%20showing%20price%20contrast%20investigative%20style&width=800&height=450&seq=art-007-main&orientation=landscape',
    tags: ['直播翻车', '成本曝光', '暴利', '消费者维权'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-008',
    title: '某综艺导师与选手传出不和，录制现场争吵画面流出',
    excerpt: '知情人透露，某导师在录制中对选手表现不满当场发飙，两人爆发激烈争执，节目组紧急暂停录制。',
    content: `<p>据现场工作人员爆料，在某音乐竞技综艺最新一期录制中，一位导师因对选手的改编不满意，当场将乐谱摔在地上，引发两人激烈争吵。</p><p>"场面一度非常尴尬，"目击者描述，"导师说选手不尊重原曲，选手回怼说导师思维固化，两人吵了将近十分钟。"</p><p>节目组随后紧急暂停录制，分别与两人沟通调解。据悉，该片段很可能被剪掉不会播出，但现场观众拍下的画面已在网络上流传。</p><blockquote><p>业内人士表示：综艺节目中的导师与选手冲突，有些是真实矛盾，有些则是节目组安排的剧本，观众很难分辨真假。</p></blockquote>`,
    category: 'zongyi-jumu',
    author: '综艺扒姐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20reporter%20portrait%20smart%20casual%20attractive%20professional%20warm%20lighting%20neutral%20background&width=80&height=80&seq=avatar-zongyi2&orientation=squarish',
    publishDate: '2026-08-04',
    readCount: 67500,
    commentCount: 2340,
    likes: 15600,
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20recording%20set%20with%20tension%20in%20the%20air%20dramatic%20lighting%20music%20competition%20stage%20conflict%20atmosphere%20cinematic%20mood%20dark%20and%20dramatic&width=800&height=450&seq=art-008-main&orientation=landscape',
    tags: ['综艺冲突', '导师选手', '录制事故', '争吵'],
    featured: false,
    hot: false,
  },
  {
    id: 'art-009',
    title: '社交平台大规模封号背后：一批"爱国大V"实为境外势力操控',
    excerpt: '权威部门通报，多个拥有数百万粉丝的"爱国大V"账号实际由境外机构操控，长期发布煽动对立情绪的内容。',
    content: `<p>近日，各大社交平台集中封禁了一批拥有数百万粉丝的"爱国大V"账号。据权威部门通报，这些账号背后实际上由境外机构操控，长期通过发布极端言论煽动社会对立情绪。</p><p>调查显示，这些账号表面上大谈爱国，但内容充满极端民族主义色彩，刻意制造群体对立。其运营团队并不在国内，而是通过VPN伪装IP地址进行操作。</p><blockquote><p>网络安全专家提醒：网民应提高辨别能力，对打着爱国旗号散布极端言论的账号保持警惕。真正的爱国是理性、包容的，而不是制造对立和仇恨。</p></blockquote><p>目前相关部门已对涉事机构展开进一步调查，并表示将依法追究相关人员的法律责任。</p>`,
    category: 'shehui-redian',
    author: '真相追踪',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20investigative%20journalist%20portrait%20stern%20professional%20dark%20background%20serious%20expression%20warm%20lighting&width=80&height=80&seq=avatar-truth&orientation=squarish',
    publishDate: '2026-08-07',
    readCount: 156000,
    commentCount: 8900,
    likes: 52300,
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20interface%20with%20account%20suspension%20notices%20dark%20digital%20atmosphere%20cybersecurity%20theme%20mysterious%20hacker%20vibe%20dramatic%20lighting%20cinematic&width=800&height=450&seq=art-009-main&orientation=landscape',
    tags: ['封号', '境外势力', '爱国大V', '网络舆论'],
    featured: true,
    hot: true,
  },
  {
    id: 'art-010',
    title: '某网红餐厅后厨卫生状况触目惊心，老鼠蟑螂随处可见',
    excerpt: '前员工实名举报某网红连锁餐厅后厨存在严重卫生问题，相关视频曝光后引发社会广泛关注。',
    content: `<p>一位自称在某网红连锁餐厅工作两年的前员工，近日实名曝光了该餐厅后厨的卫生乱象。曝光的视频中可以看到，厨房地面污水横流，食材随意堆放在地上，老鼠和蟑螂在角落出没。</p><p>"我实在看不下去了，"该前员工表示，"管理层明知卫生有问题，但只要不出事就不管。最让我无法接受的是，他们竟然把掉在地上的食材捡起来继续用。"</p><p>视频发布后，当地市场监管部门迅速介入调查。经现场检查，该餐厅确实存在多项卫生违规行为，已被责令停业整顿。</p><blockquote><p>食品安全专家呼吁：餐饮行业应建立更严格的日常监督机制，不能等曝光后才行动。消费者也应积极举报发现的食品卫生问题。</p></blockquote>`,
    category: 'shehui-redian',
    author: '民生观察',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20news%20reporter%20portrait%20concerned%20expression%20professional%20look%20warm%20lighting%20neutral%20background%20clean%20composition&width=80&height=80&seq=avatar-minsheng&orientation=squarish',
    publishDate: '2026-08-02',
    readCount: 134000,
    commentCount: 7230,
    likes: 46800,
    image: 'https://readdy.ai/api/search-image?query=Dirty%20restaurant%20kitchen%20with%20dim%20lighting%20unsanitary%20conditions%20dark%20moody%20atmosphere%20investigative%20documentary%20style%20shocking%20revelation%20contrast&width=800&height=450&seq=art-010-main&orientation=landscape',
    tags: ['食品安全', '后厨曝光', '网红餐厅', '卫生问题'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-011',
    title: '当红小生被拍到与经纪人深夜激吻，两人关系成谜',
    excerpt: '狗仔拍到某当红男演员与女经纪人在车内亲密互动，两人关系引发网友猜测。',
    content: `<p>昨日深夜，某知名狗仔团队拍到一组劲爆画面：一位当红男演员与自己的女经纪人在车内亲密激吻，两人完全未察觉被偷拍。</p><p>该男演员今年刚刚凭借一部古装剧爆红，身价倍增。而他的女经纪人比他大8岁，一直是圈内公认的"金牌经纪人"，捧红过多个艺人。</p><blockquote><p>圈内人士透露："他们在一起已经有一段时间了，只是没公开。经纪人和艺人谈恋爱其实挺常见的，只是很多人选择保密。"</p></blockquote><p>消息传出后，男方粉丝反应两极分化。有人表示祝福，也有人认为女方配不上自家偶像。目前双方均未对此事作出回应。</p>`,
    category: 'yule-bagua',
    author: '娱乐侦探小王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20paparazzi%20style%20portrait%20young%20man%20mysterious%20look%20dark%20background%20dramatic%20lighting%20clean%20composition&width=80&height=80&seq=avatar-wang2&orientation=squarish',
    publishDate: '2026-08-01',
    readCount: 189000,
    commentCount: 10200,
    likes: 67300,
    image: 'https://readdy.ai/api/search-image?query=Night%20city%20street%20luxury%20car%20interior%20dim%20lighting%20romantic%20atmosphere%20paparazzi%20night%20photography%20style%20mysterious%20mood%20cinematic%20grainy&width=800&height=450&seq=art-011-main&orientation=landscape',
    tags: ['当红小生', '经纪人恋情', '车内激吻', '娱乐圈'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-012',
    title: '某短视频平台算法被曝"制造对立"，为流量故意推送争议内容',
    excerpt: '内部员工匿名披露，平台算法会刻意放大具有争议性和对立性的内容，以提升用户活跃度和停留时长。',
    content: `<p>一位在某头部短视频平台工作三年的算法工程师匿名接受了媒体采访，披露了平台推荐算法中不为人知的"潜规则"。</p><p>"我们的算法会评估每个内容的'争议指数'，"该工程师透露，"争议越大的内容，越容易被推到更大的流量池。因为争议意味着评论、转发和讨论，这些都是平台的核心指标。"</p><p>他进一步解释，算法并不会判断内容的真实性和价值，只关注数据表现。因此，带有情绪煽动、制造对立的虚假信息往往比客观理性的内容传播得更广。</p><blockquote><p>传播学专家评论：算法推荐在追求商业利益的同时，不应忽视社会责任。平台需要建立更健康的内容生态，而不是一味追求流量最大化。</p></blockquote>`,
    category: 'shehui-redian',
    author: '科技观察者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20tech%20analyst%20portrait%20thoughtful%20expression%20modern%20casual%20style%20warm%20lighting%20neutral%20background&width=80&height=80&seq=avatar-tech&orientation=squarish',
    publishDate: '2026-07-30',
    readCount: 92000,
    commentCount: 4560,
    likes: 23400,
    image: 'https://readdy.ai/api/search-image?query=Digital%20algorithm%20visualization%20with%20dark%20background%20flowing%20data%20streams%20mysterious%20tech%20atmosphere%20social%20media%20interface%20dystopian%20vibe%20cinematic%20lighting&width=800&height=450&seq=art-012-main&orientation=landscape',
    tags: ['算法推荐', '信息茧房', '平台责任', '流量经济'],
    featured: false,
    hot: false,
  },
];